import { render } from "./Search2.vue?vue&type=template&id=4d2bae29&scoped=true&ts=true"
import script from "./Search2.vue?vue&type=script&lang=ts"
export * from "./Search2.vue?vue&type=script&lang=ts"

import "./Search2.vue?vue&type=style&index=0&id=4d2bae29&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2bae29"]])

export default __exports__